// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/cache-loader/dist/cjs.js!../../../node_modules/css-loader/index.js??ref--6-2!../../../node_modules/postcss-loader/lib/index.js??ref--6-3!./iconfont.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../node_modules/vue-style-loader/lib/addStylesClient.js")("e7dda4d6", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/iconfont.css
// module id = 7xIN
// module chunks = 79